(() => {
  const SLIDER_SELECTOR = "[data-cart-reassurance]";
  let scheduled = false;

    let TEMPLATE_HTML = null;
  let trailingInitTimer = null;

  function getTemplateHTML() {
    if (TEMPLATE_HTML) return TEMPLATE_HTML;

    const tpl =
      document.getElementById("CartDrawer-ReassuranceTemplate") ||
      document.querySelector("#CartDrawer-ReassuranceTemplate");

    if (tpl && tpl.innerHTML.trim()) {
      TEMPLATE_HTML = tpl.innerHTML.trim();
    }

    return TEMPLATE_HTML;
  }


    function injectReassurance() {
    const html = getTemplateHTML();
    if (!html) return;

    document.querySelectorAll("cart-drawer [data-cart-reassurance-mount]").forEach((mount) => {
      // If mount got replaced by AJAX, it will be empty -> re-inject
      if (!mount.querySelector(SLIDER_SELECTOR)) {
        mount.innerHTML = html;
      }
    });
  }


  function getIntervalMs(el) {
    const raw = parseFloat(el.getAttribute("data-interval") || "4000");
    // supports both "4" (seconds) and "4000" (ms)
    const ms = raw <= 20 ? raw * 1000 : raw;
    return Number.isFinite(ms) ? Math.max(2000, ms) : 4000;
  }

  class CartReassurance {
    constructor(root) {
      this.root = root;
      this.abort = new AbortController();
      this.destroyed = false;

      this.track = root.querySelector(".cart-reassurance__track");
      this.dots = Array.from(root.querySelectorAll(".cart-reassurance__dot"));
      this.originalSlides = Array.from(
        root.querySelectorAll(".cart-reassurance__slide:not(.is-reassurance-clone)")
      );
      this.originalCount = this.originalSlides.length;

      if (!this.track || this.originalCount <= 0) return;

      this.index = 0;
      this.timer = null;
      this.snapTimer = null;

      this.interval = getIntervalMs(root);

      // Drawer should keep sliding (don’t pause)
      this.reducedMotion = false;
      this.transitionMs = 520;

      this.setupLoop();
      this.bind();
      this.goTo(0, false);

      if (this.originalCount > 1) this.start();
    }

    destroy() {
      this.destroyed = true;
      this.stop();
      try {
        this.abort.abort();
      } catch (e) {}
      this.root = null;
      this.track = null;
      this.dots = [];
      this.originalSlides = [];
    }

    setupLoop() {
      if (!this.track || this.originalCount <= 1) return;

      // Clean old clone(s) if any
      this.track.querySelectorAll(".is-reassurance-clone").forEach((n) => n.remove());

      // Clone first slide to end
      const clone = this.originalSlides[0].cloneNode(true);
      clone.classList.add("is-reassurance-clone");
      clone.setAttribute("aria-hidden", "true");
      this.track.appendChild(clone);

      const onEnd = () => {
        if (this.index === this.originalCount) this.snapToFirst();
      };

      this.track.addEventListener(
        "transitionend",
        (e) => {
          if (e.propertyName === "transform") onEnd();
        },
        { signal: this.abort.signal }
      );

      this.track.addEventListener("transitioncancel", onEnd, { signal: this.abort.signal });

      document.addEventListener(
        "visibilitychange",
        () => {
          if (!document.hidden && this.index === this.originalCount) this.snapToFirst();
        },
        { signal: this.abort.signal }
      );
    }

    bind() {
      // Dot navigation (delegated)
      this.root.addEventListener(
        "click",
        (e) => {
          const dot = e.target.closest(".cart-reassurance__dot");
          if (!dot) return;

          const target = parseInt(dot.getAttribute("data-dot"), 10);
          if (!Number.isFinite(target)) return;

          if (target === 0 && this.index === this.originalCount - 1) {
            this.goTo(this.originalCount, true); // last -> clone
          } else {
            this.goTo(target, true);
          }

          this.restart();
        },
        { signal: this.abort.signal }
      );

      // IMPORTANT: DO NOT pause on hover/focus inside a drawer.
      // If you ever want it back, gate it behind an attribute:
      //
      // const pause = this.root.getAttribute("data-pause-on-hover") === "true";
      // if (pause) { ... add mouseenter/mouseleave/focusin/focusout ... }
    }

    goTo(i, animate = true) {
      if (!this.track || this.destroyed) return;

      if (this.snapTimer) {
        clearTimeout(this.snapTimer);
        this.snapTimer = null;
      }

      this.index = i;

      if (!animate) {
        this.track.style.transition = "none";
        this.track.style.transform = `translateX(-${this.index * 100}%)`;
        void this.track.offsetHeight;
        this.track.style.transition = "";
      } else {
        this.track.style.transform = `translateX(-${this.index * 100}%)`;
      }

      this.updateDots();

      if (animate && this.index === this.originalCount) {
        this.snapTimer = setTimeout(() => {
          if (!this.destroyed && this.index === this.originalCount) this.snapToFirst();
        }, this.transitionMs);
      }
    }

    snapToFirst() {
      if (!this.track || this.destroyed) return;

      if (this.snapTimer) {
        clearTimeout(this.snapTimer);
        this.snapTimer = null;
      }

      this.track.style.transition = "none";
      this.track.style.transform = "translateX(0)";
      void this.track.offsetHeight;
      this.track.style.transition = "";

      this.index = 0;
      this.updateDots();
    }

    updateDots() {
      if (!this.dots.length || this.originalCount <= 0) return;
      const displayIndex = this.index % this.originalCount;

      this.dots.forEach((d, idx) => {
        const active = idx === displayIndex;
        d.classList.toggle("is-active", active);
        d.setAttribute("aria-pressed", active ? "true" : "false");
      });
    }

    next() {
      if (this.originalCount <= 1 || this.destroyed) return;
      if (this.index === this.originalCount - 1) this.goTo(this.originalCount, true);
      else this.goTo(this.index + 1, true);
    }

    start() {
      if (this.destroyed || this.originalCount <= 1 || this.timer) return;

      const tick = () => {
        this.timer = null;
        if (this.destroyed) return;

        // If element got replaced by AJAX, stop (init() will rebuild)
        if (!this.root || !this.root.isConnected) return;

        this.next();
        this.start();
      };

      this.timer = window.setTimeout(tick, this.interval);
    }

    stop() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if (this.snapTimer) {
        clearTimeout(this.snapTimer);
        this.snapTimer = null;
      }
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  function init() {
    injectReassurance();

    document.querySelectorAll(SLIDER_SELECTOR).forEach((el) => {
      const slidesCount = el.querySelectorAll(
        ".cart-reassurance__slide:not(.is-reassurance-clone)"
      ).length;

      if (!slidesCount) return;

      const desiredInterval = getIntervalMs(el);

      // ✅ KEY FIX: don't destroy/recreate on every mutation.
      // Only rebuild if element was replaced or config changed.
      const inst = el.__cartReassurance;

      if (
        inst &&
        !inst.destroyed &&
        inst.root === el &&
        el.isConnected &&
        inst.originalCount === slidesCount &&
        inst.interval === desiredInterval
      ) {
        // still valid → keep autoplay running
        return;
      }

      if (inst) inst.destroy();
      el.__cartReassurance = new CartReassurance(el);
    });
  }

    function scheduleInit() {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        init();
      });
    }

    // Always do a trailing init a bit later (Dawn often updates in multiple async steps)
    if (trailingInitTimer) clearTimeout(trailingInitTimer);
    trailingInitTimer = setTimeout(init, 350);
  }


  document.addEventListener("DOMContentLoaded", scheduleInit);
  document.addEventListener("shopify:section:load", scheduleInit);

    // --- Replace your current observer section with this ---

  // Observe #CartDrawer AND re-attach the inner observer if Dawn swaps .drawer__inner
  let observedInner = null;
  const innerObserver = new MutationObserver(scheduleInit);

  function hookInnerObserver() {
    const root = document.getElementById("CartDrawer");
    if (!root) return;

    const inner = root.querySelector(".drawer__inner");
    if (!inner || inner === observedInner) return;

    // Dawn may replace the entire node -> rebind
    innerObserver.disconnect();
    observedInner = inner;
    innerObserver.observe(observedInner, { childList: true, subtree: true });

    scheduleInit();
  }

  const cartDrawerRoot = document.getElementById("CartDrawer");
  if (cartDrawerRoot) {
    // Watch root so we detect when .drawer__inner is swapped
    new MutationObserver(() => {
      hookInnerObserver();
      scheduleInit();
    }).observe(cartDrawerRoot, { childList: true, subtree: true });

    hookInnerObserver();
  }

  scheduleInit();

    customElements.whenDefined("cart-drawer").then(() => {
    const Cls = customElements.get("cart-drawer");
    if (!Cls || !Cls.prototype) return;

    const originalRender = Cls.prototype.renderContents;
    if (typeof originalRender === "function" && !originalRender.__patchedForReassurance) {
      function patchedRenderContents(...args) {
        const res = originalRender.apply(this, args);

        // Run after Dawn injects new HTML
        scheduleInit();
        requestAnimationFrame(scheduleInit);
        setTimeout(scheduleInit, 200);

        return res;
      }
      patchedRenderContents.__patchedForReassurance = true;
      Cls.prototype.renderContents = patchedRenderContents;
    }
  });


    customElements.whenDefined("cart-drawer").then(() => {
    const Cls = customElements.get("cart-drawer");
    if (!Cls || !Cls.prototype || !Cls.prototype.open) return;

    const originalOpen = Cls.prototype.open;
    if (originalOpen.__patchedForReassurance) return;

    function patchedOpen(...args) {
      const res = originalOpen.apply(this, args);
      scheduleInit();
      setTimeout(scheduleInit, 120);
      return res;
    }
    patchedOpen.__patchedForReassurance = true;

    Cls.prototype.open = patchedOpen;
  });

})();
